import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from './plugins/vuetify'
import store from './store/index'
import VueCookie from 'vue-cookie'
import i18n from './lang/config'
import validations from './mixins/validations'
import eventBus from './plugins/events'
import formatter from './plugins/formatters'
import api from './plugins/api_services'
import { replaceDotWithComma, replaceCommaWithDot, filterDate, filterDateTime, absoluteNumber } from './assets/js/filters'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.mixin(validations)

let filters = {
  dateFormat: filterDate,
  dateTimeFormat: filterDateTime,
  replaceDotWithComma,
  replaceCommaWithDot,
  absoluteNumber
}
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

let plugins = { formatter, VueCookie, eventBus, api }
Object.keys(plugins).forEach(key => {
  Vue.use(plugins[key])
})

/* Prompt user to install the app */
var deferredPrompt
var isShown = false
window.addEventListener('beforeinstallprompt', (e) => {
  try {
    e.preventDefault()
    deferredPrompt = e
    if (!isShown) {
      document.addEventListener('click', (e) => {
        if (!isShown) {
          deferredPrompt.prompt()
          isShown = true
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt')
            } else {
              console.log('User dismissed the A2HS prompt')
            }
            deferredPrompt = null
          })
        }
      })
    }
  } catch (ex) {
    isShown = true
  }
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  eventBus,
  render: h => h(App)
}).$mount('#app')
